import { BaseData } from './base-data'
import { RuleNodeId } from './id/rule-node-id'
import _ from 'lodash'
import { RuleChainId } from './id/rule-chain-id'

export interface RuleNode extends BaseData<RuleNodeId> {
  name: string
  type: NodeTypes
  debugMode: boolean
  positionX: number
  positionY: number
  configuration: any
  ruleChainID: RuleChainId
}

export enum NodeTypes {
  INPUT_NODE = 'inputNode',
  // Filters
  FILTER_CHECK_FIELD_EXIST = 'filterCheckFieldExistNode',
  FILTER_ASSET_PROFILE_SWITCH = 'filterAssetProfileSwitchNode',
  FILTER_ENTITY_TYPE = 'filterEntityTypeNode',
  FILTER_ENTITY_TYPE_SWITCH = 'filterEntityTypeSwitchNode',
  FILTER_MESSAGE_TYPE = 'filterMessageTypeNode',
  FILTER_MESSAGE_TYPE_SWITCH = 'filterMessageTypeSwitchNode',
  FILTER_CHECK_ALARM_STATUS = 'filterCheckAlarmStatusNode',
  FILTER_SCRIPT = 'filterScriptNode',
  // Actions
  ACTION_SAVE_TELEMETRY = 'actionSaveTelemetryNode',
  ACTION_CREATE_ALARM = 'actionCreateAlarmNode',
  ACTION_CLEAR_ALARM = 'actionClearAlarmNode',
  ACTION_ENTITY_OPERATION_CREATE = 'actionEntityOperationCreateNode',
  ACTION_ENTITY_OPERATION_FIND = 'actionEntityOperationFindNode',
  ACTION_ENTITY_OPERATION_FIND_OR_CREATE = 'actionEntityOperationFindOrCreateNode',
  // Transform
  TRANSFORM_RENAME_KEYS = 'transformRenameKeysNode',
  TRANSFORM_SCRIPT = 'transformScriptNode',
  TRANSFORM_CHANGE_ORIGIN = 'transformChangeOriginNode',
  TRANSFORM_TO_EMAIL = 'transformToEmailNode',
  // Enrichment
  ENRICHMENT_ORIGINATOR_ATTRIBUTES = 'enrichmentOriginatorAttributesNode',
  ENRICHMENT_CUSTOMER_ATTRIBUTES = 'enrichmentCustomerAttributesNode',
  ENRICHMENT_ORIGIN_TELEMETRY = 'enrichmentOriginTelemetryNode',
  // External
  EXTERNAL_SEND_NOTIFICATION = 'externalSendNotificationNode',
  FLOW_GENERATE_REPORT = 'flowGenerateReportNode',
  EXTERNAL_SEND_EMAIL = 'externalSendEmailNode',
}

type ConditionForNode = {
  value: string
  label: string
  sourceNodes: NodeTypes[] | 'all'
}

export const conditionForNode: ConditionForNode[] = [
  {
    value: 'SUCCESS',
    label: 'Success',
    sourceNodes: [
      NodeTypes.FILTER_CHECK_FIELD_EXIST,
      NodeTypes.FILTER_ASSET_PROFILE_SWITCH,
      NodeTypes.FILTER_ENTITY_TYPE,
      NodeTypes.FILTER_ENTITY_TYPE_SWITCH,
      NodeTypes.FILTER_MESSAGE_TYPE,
      NodeTypes.FILTER_MESSAGE_TYPE_SWITCH,
      NodeTypes.ACTION_SAVE_TELEMETRY,
      NodeTypes.ACTION_ENTITY_OPERATION_CREATE,
      NodeTypes.ACTION_ENTITY_OPERATION_FIND,
      NodeTypes.ENRICHMENT_CUSTOMER_ATTRIBUTES,
      NodeTypes.ENRICHMENT_ORIGINATOR_ATTRIBUTES,
      NodeTypes.TRANSFORM_SCRIPT,
      NodeTypes.TRANSFORM_CHANGE_ORIGIN,
      NodeTypes.ENRICHMENT_ORIGIN_TELEMETRY,
      NodeTypes.FLOW_GENERATE_REPORT,
      NodeTypes.TRANSFORM_TO_EMAIL,
    ],
  },
  {
    value: 'ALARM_CREATED',
    label: 'Alarm Created',
    sourceNodes: [NodeTypes.ACTION_CREATE_ALARM],
  },
  {
    value: 'ALARM_UPDATED',
    label: 'Alarm Updated',
    sourceNodes: [NodeTypes.ACTION_CREATE_ALARM],
  },
  {
    value: 'ALARM_CLEARED',
    label: 'Alarm Cleared',
    sourceNodes: [NodeTypes.ACTION_CLEAR_ALARM],
  },
  {
    value: 'CREATED',
    label: 'Created',
    sourceNodes: [NodeTypes.ACTION_ENTITY_OPERATION_FIND_OR_CREATE],
  },
  {
    value: 'FOUND',
    label: 'Found',
    sourceNodes: [NodeTypes.ACTION_ENTITY_OPERATION_FIND_OR_CREATE],
  },
  {
    value: 'FAILURE',
    label: 'Failure',
    sourceNodes: 'all',
  },
  {
    value: 'TRUE',
    label: 'True',
    sourceNodes: [NodeTypes.FILTER_SCRIPT],
  },
  {
    value: 'FALSE',
    label: 'False',
    sourceNodes: [NodeTypes.FILTER_SCRIPT, NodeTypes.ACTION_CLEAR_ALARM],
  },
]

export const getConditionForNode = (value: NodeTypes) => {
  return _.chain(conditionForNode)
    .filter((item) => {
      return item.sourceNodes.includes(value) || item.sourceNodes === 'all'
    })
    .map((item) => {
      return {
        value: item.value,
        label: item.label,
      }
    })
    .value()
}
